import { ENumberDisplayIntents } from '@src/typings';
import { NumberDisplayVariants } from '@src/utilities/NumberDisplayVariants';
import { Badge } from 'antd';
import { useTheme, withTheme } from '../ThemeProvider';
import { NumberDisplayProps } from './types';

const NumberDisplayComponent = ({
    className,
    color = ENumberDisplayIntents.Primary,
    ...props
}: NumberDisplayProps) => {
    const { theme } = useTheme();

    const getStyle = () => {
        const styles: React.CSSProperties = {};

        if (color === ENumberDisplayIntents.Primary) {
            styles.color = theme.colors.info.main.filled;
            styles.borderColor = theme.colors.info.light.border;
            styles.backgroundColor = 'transparent';
        } else if (color === ENumberDisplayIntents.Normal) {
            styles.color = theme.colors.secondary.main.text;
            styles.backgroundColor = theme.colors.secondary.light.surfaceBg;
        } else if (color === ENumberDisplayIntents.Alarmed) {
            styles.color = theme.colors.primary.main.text;
            styles.backgroundColor = theme.colors.error.main.filled;
        }

        return styles;
    };

    return (
        <Badge
            className={NumberDisplayVariants({
                className,
                color,
            })}
            style={getStyle()}
            {...props}
        />
    );
};

export const NumberDisplay = withTheme(NumberDisplayComponent);
